module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.list), function(item) {
    return _c('ul', {
      key: item.name,
      class: ['product', _vm.isBasic ? '' : 'product-combo']
    }, [(item.name === '产品内容' || item.name === '套餐内容') ? [_c('li', {
      staticStyle: {
        "font-weight": "Bold",
        "color": "#313238",
        "margin-bottom": "9px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(product, index) {
      return _c('li', {
        key: index
      }, [_c('img', {
        staticStyle: {
          "width": "16px",
          "height": "16px",
          "margin-right": "8px",
          "margin-top": "4px"
        },
        attrs: {
          "src": product.resource,
          "alt": ""
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(product.name))]), _vm._v(" "), (product.extra_info && product.extra_info.new) ? _c('span', {
        staticClass: "new"
      }, [_vm._v("new")]) : _vm._e()])
    })] : _vm._e(), _vm._v(" "), (item.name === '适用场景') ? [_c('li', {
      staticStyle: {
        "font-weight": "Bold",
        "color": "#313238"
      }
    }, [_vm._v("适用场景")]), _vm._v(" "), _vm._l((item.extra_info.scene), function(product, index) {
      return _c('li', {
        key: index,
        staticClass: "item"
      }, [_c('img', {
        staticStyle: {
          "width": "14px",
          "height": "14px",
          "margin-top": "6px",
          "margin-right": "4px"
        },
        attrs: {
          "src": require("../../images/downloads/icon-success.svg"),
          "alt": ""
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(product))])])
    })] : _vm._e(), _vm._v(" "), (item.name === '更新内容') ? void 0 : _vm._e(), _vm._v(" "), (item.name === '推荐部署所需资源和配置') ? [_c('li', {
      staticStyle: {
        "font-weight": "Bold",
        "color": "#313238",
        "margin-bottom": "9px"
      }
    }, [_vm._v("推荐部署所需资源和配置")]), _vm._v(" "), _c('li', {
      staticClass: "item"
    }, [_c('span', [_vm._v("体验环境：")]), _vm._v(" "), _c('span', {
      staticClass: "config"
    }, [_vm._v(_vm._s(_vm.config.experience_env))]), _vm._v(" "), _c('span', {}, [_vm._v(" * " + _vm._s(_vm.config.experience_num))])]), _vm._v(" "), _c('li', {
      staticClass: "item"
    }, [_c('span', [_vm._v("生产环境：")]), _vm._v(" "), _c('span', {
      staticClass: "config"
    }, [_vm._v(_vm._s(_vm.config.prod_env))]), _vm._v(" "), _c('span', {}, [_vm._v(" * " + _vm._s(_vm.config.prod_num))])]), _vm._v(" "), (_vm.config.ps) ? _c('li', {
      staticClass: "ps"
    }, [_c('span', [_vm._v("Ps：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(_vm.config.ps))])]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.isBasic && item.name === '前往部署') ? [_c('div', {
      staticClass: "combo-deploy",
      on: {
        "click": function($event) {
          return _vm.jumpPage(item)
        }
      }
    }, [_vm._v("前往部署")])] : _vm._e(), _vm._v(" "), (!_vm.isBasic && item.name === '立即下载') ? [_c('div', {
      staticClass: "combo-download",
      on: {
        "click": function($event) {
          return _vm.jumpPage(item, 'download')
        }
      }
    }, [_vm._v("立即下载")])] : _vm._e(), _vm._v(" "), (!_vm.isBasic && item.name === '安装指引') ? [_c('div', {
      staticClass: "combo-install",
      on: {
        "click": function($event) {
          return _vm.jumpPage(item)
        }
      }
    }, [_vm._v("安装指引")])] : _vm._e()], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-47cdb4ee!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/downloads/content.vue
// module id = MvIa
// module chunks = 15